import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, useContext } from 'react';
import Button from '../../Button';
import IconButton from '../../IconButton';
import { Styled } from './Footer.styles';
import { WizardContext } from '../Wizard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var useWizardContext = function useWizardContext() {
  return useContext(WizardContext);
};

var Footer = forwardRef(function (_ref, ref) {
  var rest = _extends({}, _ref);

  var _useWizardContext = useWizardContext(),
      activeStepIndex = _useWizardContext.activeStepIndex,
      customStepCount = _useWizardContext.customStepCount,
      customStepIndex = _useWizardContext.customStepIndex,
      footerActions = _useWizardContext.footerActions,
      isControlled = _useWizardContext.isControlled,
      isValid = _useWizardContext.isValid,
      nextStepTitle = _useWizardContext.nextStepTitle,
      onNextHandler = _useWizardContext.onNextHandler,
      onPrevHandler = _useWizardContext.onPrevHandler,
      prevStepTitle = _useWizardContext.prevStepTitle,
      stepCount = _useWizardContext.stepCount;

  var totalStepCount = customStepCount ? customStepCount : stepCount;
  var stepIndex = customStepIndex ? customStepIndex : activeStepIndex + 1;

  var primaryAction = function primaryAction() {
    var _footerActions$primar, _footerActions$primar2, _footerActions$primar3;

    var isHidden = (_footerActions$primar = footerActions === null || footerActions === void 0 ? void 0 : (_footerActions$primar2 = footerActions.primary) === null || _footerActions$primar2 === void 0 ? void 0 : _footerActions$primar2.isHidden) !== null && _footerActions$primar !== void 0 ? _footerActions$primar : false;
    var isDisabled = !isValid || (footerActions === null || footerActions === void 0 ? void 0 : (_footerActions$primar3 = footerActions.primary) === null || _footerActions$primar3 === void 0 ? void 0 : _footerActions$primar3.isDisabled);

    if (!isHidden) {
      var _footerActions$primar4, _footerActions$primar5, _footerActions$primar7, _footerActions$primar8, _footerActions$primar10, _footerActions$primar11, _footerActions$primar12, _footerActions$primar13, _footerActions$primar14, _footerActions$primar15, _footerActions$primar16, _footerActions$primar17;

      return _jsx(Styled.PrimaryActions, {
        children: stepIndex === totalStepCount ? _jsx(Button, {
          isDisabled: isDisabled,
          isLoading: (_footerActions$primar4 = footerActions === null || footerActions === void 0 ? void 0 : (_footerActions$primar5 = footerActions.primary) === null || _footerActions$primar5 === void 0 ? void 0 : _footerActions$primar5.isLoading) !== null && _footerActions$primar4 !== void 0 ? _footerActions$primar4 : false,
          onClick: function onClick() {
            var _footerActions$primar6;

            if (footerActions !== null && footerActions !== void 0 && (_footerActions$primar6 = footerActions.primary) !== null && _footerActions$primar6 !== void 0 && _footerActions$primar6.onClick) {
              footerActions.primary.onClick();
            } else {
              return null;
            }
          },
          variant: "primary",
          children: (_footerActions$primar7 = footerActions === null || footerActions === void 0 ? void 0 : (_footerActions$primar8 = footerActions.primary) === null || _footerActions$primar8 === void 0 ? void 0 : _footerActions$primar8.label) !== null && _footerActions$primar7 !== void 0 ? _footerActions$primar7 : 'Submit'
        }) : _jsxs(Styled.NextButton, {
          role: "button",
          disabled: isDisabled,
          onClick: function onClick() {
            var _footerActions$primar9;

            if (footerActions !== null && footerActions !== void 0 && (_footerActions$primar9 = footerActions.primary) !== null && _footerActions$primar9 !== void 0 && _footerActions$primar9.onClick) {
              footerActions.primary.onClick();
            }

            if (stepCount > 1 && activeStepIndex < stepCount) {
              !isControlled && onNextHandler();
            } else {
              return null;
            }
          },
          children: [_jsxs(Styled.Label, {
            children: [_jsx(Styled.Overline, {
              isDisabled: isDisabled,
              children: (_footerActions$primar10 = footerActions === null || footerActions === void 0 ? void 0 : (_footerActions$primar11 = footerActions.primary) === null || _footerActions$primar11 === void 0 ? void 0 : _footerActions$primar11.overline) !== null && _footerActions$primar10 !== void 0 ? _footerActions$primar10 : 'Next'
            }), _jsx(Styled.StepTitle, {
              isDisabled: isDisabled,
              children: (_footerActions$primar12 = footerActions === null || footerActions === void 0 ? void 0 : (_footerActions$primar13 = footerActions.primary) === null || _footerActions$primar13 === void 0 ? void 0 : _footerActions$primar13.label) !== null && _footerActions$primar12 !== void 0 ? _footerActions$primar12 : nextStepTitle
            })]
          }), _jsx(IconButton, {
            icon: (_footerActions$primar14 = footerActions === null || footerActions === void 0 ? void 0 : (_footerActions$primar15 = footerActions.primary) === null || _footerActions$primar15 === void 0 ? void 0 : _footerActions$primar15.icon) !== null && _footerActions$primar14 !== void 0 ? _footerActions$primar14 : 'chevron-right',
            isDisabled: isDisabled,
            isLoading: (_footerActions$primar16 = footerActions === null || footerActions === void 0 ? void 0 : (_footerActions$primar17 = footerActions.primary) === null || _footerActions$primar17 === void 0 ? void 0 : _footerActions$primar17.isLoading) !== null && _footerActions$primar16 !== void 0 ? _footerActions$primar16 : false
          })]
        })
      });
    } else {
      return null;
    }
  };

  var secondaryAction = function secondaryAction() {
    var _footerActions$second, _footerActions$second2;

    var isHidden = (_footerActions$second = footerActions === null || footerActions === void 0 ? void 0 : (_footerActions$second2 = footerActions.secondary) === null || _footerActions$second2 === void 0 ? void 0 : _footerActions$second2.isHidden) !== null && _footerActions$second !== void 0 ? _footerActions$second : false;

    if (!isHidden) {
      var _footerActions$second3, _footerActions$second4, _footerActions$second7, _footerActions$second8, _footerActions$second9, _footerActions$second10, _footerActions$second11, _footerActions$second12, _footerActions$second13, _footerActions$second14, _footerActions$second15, _footerActions$second16;

      return _jsxs(Styled.PrevButton, {
        role: "button",
        disabled: (_footerActions$second3 = footerActions === null || footerActions === void 0 ? void 0 : (_footerActions$second4 = footerActions.secondary) === null || _footerActions$second4 === void 0 ? void 0 : _footerActions$second4.isDisabled) !== null && _footerActions$second3 !== void 0 ? _footerActions$second3 : false,
        onClick: function onClick() {
          if (stepCount > 1) {
            var _footerActions$second5;

            if (footerActions !== null && footerActions !== void 0 && (_footerActions$second5 = footerActions.secondary) !== null && _footerActions$second5 !== void 0 && _footerActions$second5.onClick) {
              footerActions.secondary.onClick();
            }

            !isControlled && onPrevHandler();
          } else {
            var _footerActions$second6;

            if (footerActions !== null && footerActions !== void 0 && (_footerActions$second6 = footerActions.secondary) !== null && _footerActions$second6 !== void 0 && _footerActions$second6.onClick) {
              footerActions.secondary.onClick();
            }

            return null;
          }
        },
        children: [_jsx(IconButton, {
          icon: (_footerActions$second7 = footerActions === null || footerActions === void 0 ? void 0 : (_footerActions$second8 = footerActions.secondary) === null || _footerActions$second8 === void 0 ? void 0 : _footerActions$second8.icon) !== null && _footerActions$second7 !== void 0 ? _footerActions$second7 : 'chevron-left',
          isDisabled: (_footerActions$second9 = footerActions === null || footerActions === void 0 ? void 0 : (_footerActions$second10 = footerActions.secondary) === null || _footerActions$second10 === void 0 ? void 0 : _footerActions$second10.isDisabled) !== null && _footerActions$second9 !== void 0 ? _footerActions$second9 : false,
          isLoading: (_footerActions$second11 = footerActions === null || footerActions === void 0 ? void 0 : (_footerActions$second12 = footerActions.secondary) === null || _footerActions$second12 === void 0 ? void 0 : _footerActions$second12.isLoading) !== null && _footerActions$second11 !== void 0 ? _footerActions$second11 : false,
          variant: "secondary"
        }), _jsxs(Styled.Label, {
          children: [_jsx(Styled.Overline, {
            children: (_footerActions$second13 = footerActions === null || footerActions === void 0 ? void 0 : (_footerActions$second14 = footerActions.secondary) === null || _footerActions$second14 === void 0 ? void 0 : _footerActions$second14.overline) !== null && _footerActions$second13 !== void 0 ? _footerActions$second13 : 'Back'
          }), _jsx(Styled.StepTitle, {
            children: (_footerActions$second15 = footerActions === null || footerActions === void 0 ? void 0 : (_footerActions$second16 = footerActions.secondary) === null || _footerActions$second16 === void 0 ? void 0 : _footerActions$second16.label) !== null && _footerActions$second15 !== void 0 ? _footerActions$second15 : prevStepTitle
          })]
        })]
      });
    } else {
      return null;
    }
  };

  var tertiaryAction = function tertiaryAction() {
    var _footerActions$tertia, _footerActions$tertia2;

    var isHidden = (_footerActions$tertia = footerActions === null || footerActions === void 0 ? void 0 : (_footerActions$tertia2 = footerActions.tertiary) === null || _footerActions$tertia2 === void 0 ? void 0 : _footerActions$tertia2.isHidden) !== null && _footerActions$tertia !== void 0 ? _footerActions$tertia : false;

    if (!isHidden && footerActions !== null && footerActions !== void 0 && footerActions.tertiary) {
      var _footerActions$tertia3, _footerActions$tertia4, _footerActions$tertia5, _footerActions$tertia6, _footerActions$tertia7, _footerActions$tertia8, _footerActions$tertia9;

      return _jsx(Styled.TertiaryActions, {
        children: _jsx(Button, {
          iconLeft: (_footerActions$tertia3 = footerActions.tertiary) === null || _footerActions$tertia3 === void 0 ? void 0 : _footerActions$tertia3.icon,
          isDisabled: (_footerActions$tertia4 = (_footerActions$tertia5 = footerActions.tertiary) === null || _footerActions$tertia5 === void 0 ? void 0 : _footerActions$tertia5.isDisabled) !== null && _footerActions$tertia4 !== void 0 ? _footerActions$tertia4 : false,
          isLoading: (_footerActions$tertia6 = (_footerActions$tertia7 = footerActions.tertiary) === null || _footerActions$tertia7 === void 0 ? void 0 : _footerActions$tertia7.isLoading) !== null && _footerActions$tertia6 !== void 0 ? _footerActions$tertia6 : false,
          onClick: (_footerActions$tertia8 = footerActions.tertiary) === null || _footerActions$tertia8 === void 0 ? void 0 : _footerActions$tertia8.onClick,
          variant: "secondary",
          children: (_footerActions$tertia9 = footerActions.tertiary) === null || _footerActions$tertia9 === void 0 ? void 0 : _footerActions$tertia9.label
        })
      });
    } else {
      return null;
    }
  };

  return _jsxs(Styled.Footer, _objectSpread(_objectSpread({
    ref: ref
  }, rest), {}, {
    children: [_jsx(Styled.SecondaryActions, {
      children: stepIndex > 1 && secondaryAction()
    }), tertiaryAction(), primaryAction()]
  }));
});
export default Footer;